import { render, staticRenderFns } from "./TaskMoneyConfigtaskpass.vue?vue&type=template&id=84e9b512&"
import script from "./TaskMoneyConfigtaskpass.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigtaskpass.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigtaskpass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports